export { default as WSendToBot } from '@/widgets/WSendToBot/WSendToBot.vue'
